// extracted by mini-css-extract-plugin
export var hidden = "navbarMenu-module--hidden--89d99";
export var link = "navbarMenu-module--link--a0bb4";
export var menu = "navbarMenu-module--menu--00e00";